"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.default = {
    'socialMediaPlan.creator.title': 'Creatore post',
    'socialMediaPlan.creator.subtitle': 'Brief → Anteprima AI → Pianifica',
    'socialMediaPlan.creator.selectPlatform': 'Seleziona almeno una piattaforma',
    'socialMediaPlan.creator.fillBrief': 'Inserisci argomento e piattaforme',
    'socialMediaPlan.creator.aiError': 'Generazione AI fallita.',
    'socialMediaPlan.creator.generate.title': 'Genera contenuto per ogni piattaforma',
    'socialMediaPlan.creator.generate.desc': 'Completa il brief e genera.',
    'socialMediaPlan.creator.generateBtn': 'Genera con AI',
    'socialMediaPlan.creator.generating': 'Generazione...',
    'socialMediaPlan.creator.manually': 'Scrivi manualmente',
    'socialMediaPlan.creator.regenerate': 'Rigenera tutto',
    'socialMediaPlan.creator.caption': 'Didascalia',
    'socialMediaPlan.creator.imagePrompt': 'Prompt immagine',
    'socialMediaPlan.creator.imagePromptPlaceholder': 'Descrivi l\'immagine...',
    'socialMediaPlan.creator.generateImage': 'Genera immagine',
    'socialMediaPlan.creator.imagePromptRequired': 'Inserisci prima il prompt',
    'socialMediaPlan.creator.imageError': 'Generazione immagine fallita.',
    'socialMediaPlan.creator.videoUpload': 'File video (YouTube / TikTok)',
    'socialMediaPlan.creator.videoUploadHint': 'Richiesto per YouTube e TikTok.',
    'socialMediaPlan.creator.videoChoose': 'Scegli file video',
    'socialMediaPlan.creator.imageSection': 'Immagine',
    'socialMediaPlan.creator.imagePromptLabel': 'Genera con AI',
    'socialMediaPlan.creator.imageUploadLabel': 'Oppure carica la tua immagine',
    'socialMediaPlan.creator.imageChoose': 'Scegli file immagine',
    'socialMediaPlan.creator.imageClear': 'Rimuovi immagine',
    'socialMediaPlan.creator.videoUploadOnNext': 'Il video verrà caricato al clic su Avanti.',
    'socialMediaPlan.creator.videoReady': 'Video pronto per la pubblicazione.',
    'socialMediaPlan.creator.videoError': 'Caricamento video fallito.',
    'socialMediaPlan.creator.tip2026Title': 'Suggerimento trend 2026',
    'socialMediaPlan.creator.tip2026Text': 'I contenuti brevi e autentici con un CTA chiaro generano ancora il massimo coinvolgimento. Caroselli e reel video hanno attualmente la maggiore portata organica.',
    'socialMediaPlan.creator.brandName': 'Il tuo brand',
    'socialMediaPlan.creator.now': 'ora',
    'socialMediaPlan.creator.like': 'Mi piace',
    'socialMediaPlan.creator.comment': 'Commenta',
    'socialMediaPlan.creator.share': 'Condividi',
    'socialMediaPlan.creator.fbPageLabel': 'Pagina Facebook',
    'socialMediaPlan.creator.fbNoPages': 'Nessuna pagina Facebook trovata. Collega il tuo account nelle impostazioni.',
    'socialMediaPlan.creator.liPageLabel': 'Pagina LinkedIn',
    'socialMediaPlan.creator.ptBoardLabel': 'Bacheca Pinterest',
    'socialMediaPlan.creator.ptNoBoards': 'Nessuna bacheca Pinterest trovata. Collega il tuo account nelle impostazioni.',
    'socialMediaPlan.creator.postContent': 'Contenuto del post',
    'socialMediaPlan.creator.hashtags': 'Hashtag',
    'socialMediaPlan.creator.hashtagsHint': 'separati da spazio',
    'socialMediaPlan.creator.aiInsightTitle': 'Suggerimento AI',
    'socialMediaPlan.creator.bestTime': 'Momento migliore:',
    'socialMediaPlan.creator.charLimit': 'Limite caratteri:',
    'socialMediaPlan.creator.videoRemove': 'Rimuovi video',
};
